import { render, staticRenderFns } from "./SectionInformation.vue?vue&type=template&id=76b97364&scoped=true&"
import script from "./SectionInformation.vue?vue&type=script&lang=js&"
export * from "./SectionInformation.vue?vue&type=script&lang=js&"
import style0 from "./SectionInformation.vue?vue&type=style&index=0&id=76b97364&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76b97364",
  null
  
)

export default component.exports